import React from "react"
import "./index.scss"

type ButtonSecondaryProps = {
    type: 'button' | 'submit' | 'reset'
    children: React.ReactNode,
    size?: string,
    id?: string,
    onClick?: () => void,
    disabled?: boolean,
    active?: boolean,
    variant?: string,
    className?: string
}
export const ButtonSecondary = ({id, type, children, size = 'large', onClick, active, variant, className,disabled}: ButtonSecondaryProps) => {
    return (
        <button 
            disabled={disabled}
            id={id}
            type={type} 
            onClick={onClick}
            className={`buttonSecondary buttonSecondary-${size} ${active ? 'buttonSecondary--active': ''} ${variant ? 'buttonSecondary--' + variant: ''} ${className ?? ''}`}>
            {children}
        </button>
    )
}